import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

export interface LanguageOption {
	code: string;
	label: string;
	nativeLabel: string;
	flag: string; // ruta al SVG de bandera (assets/flags)
}

export interface LanguageSelectorData {
	currentLang: string;
}

/**
 * Selector de idioma en diálogo (portado de agu_infoagua__admin).
 * Solo los idiomas disponibles en Centros: español e inglés (sin portugués).
 */
@Component({
	standalone: false,
	selector: "app-language-selector-dialog",
	templateUrl: "./language-selector-dialog.component.html",
	styleUrls: ["./language-selector-dialog.component.scss"],
})
export class LanguageSelectorDialogComponent implements OnInit {
	languages: LanguageOption[] = [
		{ code: "es", label: "", nativeLabel: "Español", flag: "assets/flags/es.svg" },
		{ code: "en", label: "", nativeLabel: "English", flag: "assets/flags/gb.svg" },
	];

	selectedCode: string;

	constructor(
		private readonly dialogRef: MatDialogRef<LanguageSelectorDialogComponent>,
		private readonly translateService: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: LanguageSelectorData,
	) {
		this.selectedCode = data?.currentLang || "es";
	}

	ngOnInit(): void {
		this.languages.forEach((lang) => {
			lang.label = this.translateService.instant("languages." + lang.code);
		});
	}

	selectLanguage(code: string): void {
		this.selectedCode = code;
	}

	confirm(): void {
		this.dialogRef.close(this.selectedCode);
	}

	cancel(): void {
		this.dialogRef.close(null);
	}
}
